import classNames from "classnames";
import { DComponent } from "../../../../components/DComponent";
import { Dimension } from "../../../../models/ProductVariant";
import { replaceVariable } from "../../../../utils/string";
import { isEmpty } from "../../../../utils/utils";
import SelectBox from "../../../../components/SelectBox";

class DimensionItem extends DComponent {
  constructor({
    parent,
    id,
    currentValue,
    dimension = new Dimension(),
    onClick = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("DimensionItem"),
      value: dimension.dimensionCode
    }, true);
    this.currentValue = currentValue;
    /** @type {Dimension} */
    this.dimension = dimension;
    this.onClick = onClick;
    /** @type {SelectBox} */
    this.selectBox = undefined;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "DimensionItem");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.fillData();
  }

  fillData() {
    this.dimension.values.forEach(element => {
      if (element.items.length) {
        if (this.dimension.displayType === Dimension.TYPE.DROPDOWN) {
          let labelText = element.label || this.dimension.label || "";
          this.selectBox = new SelectBox({
            parent: $(".dimension-select", this.element),
            labelText: labelText,
            defaultValue: this.currentValue,
            onChange: (value) => {
              typeof (this.onClick) === "function" && this.onClick(this.dimension?.dimensionCode, value);
            },
            options: {
              render: {
                item: function (item, escape) {
                  let image = (JSON.parse($(item).attr("data-search")) || {}).image
                  return `
                    <div class="option">
                      ${image ? `<img class="icon-option" alt="" src="${image}"/>` : ""}
                      <div class="label-item">${escape(item.label)}</div>
                    </div>
                  `;
                },
                option: function (item, escape) {
                  let image = (JSON.parse($(item).attr("data-search")) || {}).image
                  return `
                    <div class="option">
                      ${image ? `<img class="icon-option" alt="" src="${image}"/>` : ""}
                      <div class="label-item">${escape(item.label)}</div>
                    </div>
                  `;
                }
              },
            }
          })
          labelText && this.selectBox.setPlaceholder("Select " + labelText + "...")
          this.selectBox.addOption(element.items);
          $(this.element).addClass("is-select");
        } else {
          let htmlItems = "", curItem = "";
          element.items.forEach(item => {
            if (this.currentValue === item.value) curItem = item;
            htmlItems += `
            <div class="item${this.currentValue === item.value ? " active" : ""}"  d-code="${this.dimension.dimensionCode}-${item.value}" d-value="${item.value}" title="${item.label}" d-label="${element.label || this.dimension.label}">
              ${item.image ? `<div class="image-value"><img src="${item.image}" alt=""/></div>` :
                item.color ? `<div class="image-value"><div style="background: ${item.color};" class="color"></div></div>` :
                  `<div class="text">${item.label}</div>`
              }
            </div>
        `
          })
          $(".collapse", this.element).append(replaceVariable(require("html-loader!./item.html"), {
            label: (element.label || this.dimension.label) ? (element.label || this.dimension.label) + ":" : "",
            classLabel: !(element.label || this.dimension.label) ? " hide" : "",
            value: curItem?.label || "",
            values: htmlItems,
          }))
          if (curItem) this.setCurrentDimension(element.label || this.dimension.label, curItem.label, curItem.image);
        }
      }
    });
    $(".dimension-values .item", this.element).on("click", (e) => {
      $(".dimension-values .item", this.element).removeClass("active");
      $(".dimension-item .value", this.element).text("");
      $(e.currentTarget).addClass("active");
      typeof (this.onClick) === "function" && this.onClick(this.dimension?.dimensionCode, $(e.currentTarget).attr("d-value"))
    })

    $(".dimension-values .item", this.element).on("mouseover", (e) => {
      let label = $(e.currentTarget).attr("title");
      label && $(e.currentTarget).parent().parent().find(".value").text(label);
    })

    $(".dimension-values", this.element).on("mouseleave", (e) => {
      $(".dimension-item .value", this.element).text("");
      let valueActive = $(".dimension-item .item.active", this.element);
      valueActive.parent().parent().find(".value").text(valueActive.attr("title"));
    })
  }

  setCurrentDimension(label, value, image) {
    if (!isEmpty(label)) {
      $(".dimension-head .label", this.element).text(label + ":");
      $(".dimension-head .label", this.element).removeClass("hide");
    } else {
      $(".dimension-head .label", this.element).addClass("hide");
    }
    $(".dimension-head .value", this.element).text(value);
    if (image) {
      $(".dimension-head .image-value", this.element).attr("src", image);
      $(".dimension-head .image-value", this.element).removeClass("hide");
    } else {
      $(".dimension-head .image-value", this.element).addClass("hide");
    }
  }


  setActiveDimensions(activeDim) {
    if (activeDim.selectedDimension) {
      this.currentValue = activeDim.selectedDimension[this.dimension.dimensionCode];
      $(`.item`, this.element).removeClass("active");
      Object.keys(activeDim.selectedDimension).forEach(key => {
        if (key === this.dimension.dimensionCode) {
          let valueActive = $(`.item[d-code='${key}-${activeDim.selectedDimension[key]}']`, this.element);
          if (valueActive?.length) {
            valueActive.addClass("active");
            valueActive.parent().parent().find(".value").text(valueActive.attr("title"));
            this.setCurrentDimension(valueActive.attr("d-label"), valueActive.attr("title"), valueActive.find("img").attr("src"));
          }
          if (this.selectBox) {
            this.selectBox.setValue(this.currentValue);
          }
        }
      });
    }

    this.dimension.values.forEach(value => {
      value.items.forEach(item => {
        let dimensionItem = $(`.item[d-code='${this.dimension.dimensionCode}-${item.value}']`);
        dimensionItem?.length && dimensionItem.removeClass("available");
        if (this.selectBox) {
          this.selectBox.element.find(`.option[data-value='${item.value}']`).addClass("not-available");
        }
        if (activeDim[this.dimension.dimensionCode] && activeDim[this.dimension.dimensionCode][item.value]) {
          dimensionItem?.length && dimensionItem.addClass("available");
          if (this.selectBox) {
            this.selectBox.element.find(`.option[data-value='${item.value}']`).removeClass("not-available");
          }
        }
      });
    });
  }
}

export default DimensionItem;